module.exports = __webpack_public_path__ + "assets/GoldMu.088a1ba1c0cb90b8c6e6d0148f3c09dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldMu.png
// module id = 766
// module chunks = 0